// src/components/MachineTable.js
import React from 'react';
import './Machanedteable.css';

const Injectiounit = () => {
  const headers = [
    'Model',
    'BJ50-V6/S6',
    'BJ90-V6/S6',
    'BJ126-V6/S6',
    'BJ160-V6/S6',
    'BJ200-V6/S6',
  ];

const rows = [
  ['Screw Diameter (mm)', '26 28 30', '30 36 42', '36 40 45', '42 46 52', '46 52 60'],
  ['Screw L/D Ratio', '21.3 20 18.3', '20.7 20 17.2', '23 20 18.2', '22 20 17.4', '23 19.9 17.5'],
  ['Injection Pressure (MPa)', '257 221 193', '266 185 136', '205 166 131', '213 177 139', '230 180 135'],
  ['Shot Volume (cm³)', '63 74 85', '113 163 222', '193 238 302', '284 340 435', '407 520 693'],
  ['Shot Weight (PS) g', '54 62 75', '101 145 198', '173 213 270', '253 302 387', '362 462 617'],
  ['Shot Weight (PS) oz', '2 2.4 2.8', '3.6 5.1 7', '6.1 7.5 9.5', '8.9 10.7 13.7', '12.8 16.3 21.8'],
  ['Injection Rate (g/s)', '54 62 72', '54 78 106', '88 109 137', '105 126 161', '119 153 203'],
  ['Plasticizing Capacity (g/s)', '10 12 14', '13 19 26', '17 23 32', '19 27 36', '28 38 55'],
  ['Screw Stroke (mm)', '120', '160', '190', '205', '245'],
  ['Screw Speed (rpm)', '206', '174', '190', '210',	'170'],
];


  return (
    <div
      className="container"
      style={{ border: '1px solid lightgray', padding: 0, marginTop: 0 }}
    >
      <div className="responsive-table">
        <table>
          <thead>
            <tr>
              <th colSpan={headers.length} className="unit-row">
                Injection Unit
              </th>
            </tr> 
            <tr>
              {headers.map((head) => (
                <th key={head}>{head}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>
                {row.map((cell, j) => (
                  <td key={j}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Injectiounit;
